import styled from 'styled-components'

export const MainWrapper = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
  height: 100%;
`
export const IconWrapper = styled.span`
  width: ${({ width }) => width ? `${width}px` : '100%'};
  margin-top: ${({ mt, my }) => mt ? mt : my ? my : '0'};
  margin-bottom: ${({ mb, my }) => mb ? mb : my ? my : '0'};
  margin-left: ${({ ml, mx }) => ml ? ml : mx ? mx : '0'};
  margin-right: ${({ mr, mx }) => mr ? mr : mx ? mx : '0'};
`

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
`

export const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 10px;
`